export default function getMadaiURL() {
  return 'https://madai.com'
  //return 'http://shop.madai.com/consumer/';
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/getMadaiURL.js
 **/